import React, { useState, useEffect, useContext, useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useTranslation } from "react-i18next";
import { esES, caES } from "@mui/x-date-pickers/locales";
import "moment/locale/es";
import "moment/locale/ca";
import "./App.scss";
import "./routes/pages/Page.css";
import "./routes/pages/Comments.css";
import "./../src/providers/pagination.css";
import "./routes/pages/proveedor/provStyles.css";
import ProtectedRoute from "./providers/ProtectedRoute";
import ChatEliteWidget from "./components/ChatElite/widget/ChatEliteWidget";
import AvisosChatEliteStaff from "./components/ChatElite/panel/AvisosChatEliteStaff";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Navigate, useLocation } from "react-router-dom";
import { UsuarioContext } from "./providers/userContext";
import { logout } from "./services";
import useInactivity from "./utilities/useInactivity";
import { useDataCache } from "./hooks";
import { VisitQueueProvider } from "./providers/visitQueueContext";

const muiLocales = {
  es: esES,
  ca: caES,
  eu: esES,
};


function App(props) {
  const user = useContext(UsuarioContext);
  const [mobile, setMobile] = useState(false);
  const { states, groups, loading, statesSupps } = useDataCache();
  const [sidebar, setSidebar] = useState(true);
  const { i18n } = useTranslation();

  const muiLocale = useMemo(() => {
    return muiLocales[i18n.language] || muiLocales.es;
  }, [i18n.language]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const location = useLocation();

  function handleResize() {
    if (window.innerWidth <= 992) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }
  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  useInactivity(logout, 7200 * 1000);  // 2 horas

  const isNewProfile = user?.tieneLegalia && user?.rol === "AAFF";

  return user === null ? <Navigate replace to="/login" state={{ from: location }} /> : (
    <div className="App">
      <VisitQueueProvider>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language} localeText={muiLocale.components.MuiLocalizationProvider.defaultProps.localeText}>
        {mobile ? (
          <div
            className="contenedor-global"
            style={{ marginLeft: 0 }}
          >
            <ProtectedRoute
              user={user}
              showSidebar={showSidebar}
              type={"menuMov"}
            />
          </div>
        ) : (
          <div
            className="contenedor-global"
            style={{ marginLeft: isNewProfile ? "220px" : sidebar ? "300px" : "100px" }}
          >
            <ProtectedRoute
              user={user}
              showSidebar={showSidebar}
              type={"menu"}
            />
          </div>
        )}
      </LocalizationProvider>
      <ChatEliteWidget />
      <AvisosChatEliteStaff />
      </VisitQueueProvider>
    </div>
  );
}

export default App;
